import { Action } from 'redux';
import { GetBarcodeFormPayload, Barcode } from '../../models/barcode';
import { APIError } from '../../helpers/types';

export enum BarcodeActionTypes {
  ACTION_GET_BARCODE_DETAILS_SUBMIT = 'GET_BARCODE_DETAILS_SUBMIT',
  ACTION_GET_BARCODE_DETAILS_SUBMIT_SUCCESS = 'GET_BARCODE_DETAILS_SUBMIT_SUCCESS',
  ACTION_GET_BARCODE_DETAILS_SUBMIT_ERROR = 'GET_BARCODE_DETAILS_SUBMIT_ERROR',
  ACTION_HEALTH_INIT = 'HEALTH_INIT',

  ACTION_BASIC_HEALTH_SUBMIT = 'BASIC_HEALTH_SUBMIT',
  ACTION_BASIC_HEALTH_SUBMIT_SUCCESS = 'BASIC_HEALTH_SUBMIT_SUCCESS',
  ACTION_BASIC_HEALTH_SUBMIT_ERROR = 'BASIC_HEALTH_SUBMIT_ERROR',

  ACTION_HEALTH_QUESTIONNAIRE_SUBMIT = 'HEALTH_QUESTIONNAIRE_SUBMIT',
  ACTION_HEALTH_QUESTIONNAIRE_SUCCESS = 'HEALTH_QUESTIONNAIRE_SUBMIT_SUCCESS',
  ACTION_HEALTH_QUESTIONNAIRE_ERROR = 'HEALTH_QUESTIONNAIRE_SUBMIT_ERROR',
}
export interface ActionGetBarcodeDetailsSubmit extends Action {
  type: BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT;
  payload: GetBarcodeFormPayload;
}
export interface ActionGetBarcodeDetailsSubmitSuccess extends Action {
  type: BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT_SUCCESS;
  payload: Barcode;
}
export interface ActionGetBarcodeDetailsSubmitError extends Action {
  type: BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT_ERROR;
  error: APIError;
}
export type BarcodeActions =
  | ActionGetBarcodeDetailsSubmit
  | ActionGetBarcodeDetailsSubmitSuccess
  | ActionGetBarcodeDetailsSubmitError
  ;